import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { SectionTitle, FeatureCard } from '../common';
import { staggerContainer, viewportConfig } from '../../utils/animations';
import { WHY_US_FEATURES } from '../../utils/constants';

const WhyUs = () => {
  return (
    <Box
      id="why-us"
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <SectionTitle
          overline="Why Choose Us"
          title="The ITorama Difference"
          subtitle="We bring expertise, dedication, and innovation to property management, ensuring your investments are in the best hands."
        />

        <Box
          component={motion.div}
          initial="hidden"
          whileInView="visible"
          viewport={viewportConfig}
          variants={staggerContainer}
        >
          <Grid container spacing={3}>
            {WHY_US_FEATURES.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={feature.id}>
                <FeatureCard
                  title={feature.title}
                  description={feature.description}
                  icon={feature.icon}
                  index={index}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default WhyUs;
